import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from '../authorization/authorization.service';
import { WindowRef } from '../../utils/window';
import { TranslateService } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';



@Component({
    selector: 'div.dtf-logout',
    imports: [SharedTranslateModule,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatNativeDateModule, MatSortModule,
        MatDatepickerModule, MatIconModule
    ],
    templateUrl: './logout.component.html',
    providers: [
    //  ClassesUtil, WindowRef
    ]
})

export class LogoutComponent implements OnInit {
    title = 'Logout';
    router: Router;
    usUrl: string;
    userId: string;
    isAdminAuth:string;
    bodyLoaded = false
    isAuthenticated = false;
    constructor(
        router: Router,
        public auth: AuthorizationService,
        private _window: WindowRef, public translate: TranslateService

        ) {
            this.router = router;
            this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    }

    ngOnInit() {
        const language = (this._window.nativeWindow as any).mbfs.language;
        this.auth.cast.subscribe(data => (this.isAuthenticated = data));
        this.userId = sessionStorage.getItem('loginID');
        this.isAdminAuth = sessionStorage.getItem('adminauth');
        const clearSessionDataRequest = {
          userId : this.userId
        };

        this.clearSessionData(clearSessionDataRequest);

        sessionStorage.clear(); //clears all sessionStorage Objects
        this.auth.isLoginAttempt(false); // makes redirect to myAccount False
        this.auth.isAuthenticated(); // Checks if user is authenticated
        if(this.isAdminAuth ==="yes"){
          window.location.href = this.usUrl + '/home/acm';
        }
        else{
          if (language === 'en-CA') {
            this.router.navigate(['ca/en/home']);
          } else if (language === 'fr-CA') {
            this.router.navigate(['ca/fr/home']);
          } else {
            this.router.navigate(['home']);
          }
        }
       }

      clearSessionData(clearSessionDataRequest) { //BE call to clear CIAM_SESSION TABLE
        this.auth.clearSessionData(clearSessionDataRequest).subscribe(res => {
      });
      }
}

